// ============================================================
// PawsomePal — Creator gift auto-add (size-gated, stability-hardened)
// Runs ONLY for creator sessions (?ppref / pp_creator_ref). Inert for everyone
// else — returns before touching the page, so normal ATC is never affected.
//   • XXS / XS / S harness -> free Matching Bandana (54260302020892)
//   • M / L harness        -> free 120 Waste Bag Refills (54285643284764)
// "Any small harness present -> bandana" wins in a mixed cart.
// Never touches the PAID refill (54225342267676) — only the two $0 gift variants.
// ============================================================
(function () {
  'use strict';

  var BANDANA_VARIANT_ID = 54260302020892;   // $0 Matching Bandana
  var REFILL_VARIANT_ID  = 54285643284764;   // $0 120 Waste Bag Refills (gift)
  var URL_PARAM   = 'ppref';
  var REF_KEY     = 'pp_creator_ref';
  var COUNT_KEY   = 'pp_last_harness_count';
  var ATTR_KEY    = 'creator_ref';
  var HARNESS_MATCH = 'Dog Harness';
  var SMALL = ['XXS', 'XS', 'S'];
  var ML    = ['M', 'L'];

  var _fetch = window.fetch;   // captured BEFORE we install our detector below

  try {
    var urlRef = new URLSearchParams(window.location.search).get(URL_PARAM);
    if (urlRef) {
      urlRef = urlRef.trim().toLowerCase();
      if (urlRef) {
        localStorage.setItem(REF_KEY, urlRef);
        document.cookie = 'pp_creator_ref=' + urlRef + ';path=/;max-age=2592000';
      }
    }
  } catch (e) {}

  function getRef() { try { return localStorage.getItem(REF_KEY); } catch (e) { return null; } }

  // HARD GATE: not a creator session -> do nothing at all.
  if (!getRef()) return;

  function getLastCount() {
    try { var v = parseInt(localStorage.getItem(COUNT_KEY), 10); return isNaN(v) ? 0 : v; }
    catch (e) { return 0; }
  }
  function setLastCount(n) { try { localStorage.setItem(COUNT_KEY, String(n)); } catch (e) {} }

  // All cart reads/writes use _fetch so our own detector never sees them (no self-loop).
  function getCart() {
    return _fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
  }
  function countHarnesses(cart) {
    var t = 0;
    cart.items.forEach(function (i) {
      if (i.product_title && i.product_title.indexOf(HARNESS_MATCH) !== -1) t += i.quantity;
    });
    return t;
  }
  function desiredGift(cart) {
    var small = false, ml = false;
    cart.items.forEach(function (i) {
      if (i.product_title && i.product_title.indexOf(HARNESS_MATCH) !== -1) {
        var s = (i.variant_title || '').trim().toUpperCase();
        if (SMALL.indexOf(s) !== -1) small = true;
        if (ML.indexOf(s) !== -1) ml = true;
      }
    });
    if (small) return 'bandana';   // small wins in a mixed cart
    if (ml) return 'refill';
    return 'none';
  }
  function linesFor(cart, variantId) {
    return cart.items.filter(function (i) { return i.variant_id === variantId; });
  }
  function addGift(variantId) {
    return _fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1, sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname })
    }).then(function (r) { return r.json(); });
  }
  function removeLine(key) {
    return _fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    });
  }
  function writeRef(ref) {
    var attrs = {}; attrs[ATTR_KEY] = ref;
    return _fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    });
  }

  // Guarded render — never blank a non-empty cart.
  function applyDrawer(sections, expectItems) {
    try {
      if (sections && sections['cart-drawer']) {
        var doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
        var fresh = doc.querySelector('#CartDrawer');
        var cur = document.getElementById('CartDrawer');
        var freshHasItems = fresh && fresh.querySelector('.cart-item');
        if (fresh && cur && (freshHasItems || !expectItems)) cur.innerHTML = fresh.innerHTML;
      }
      if (sections && sections['cart-icon-bubble']) {
        var bd = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
        var bn = bd.querySelector('#cart-icon-bubble'), bc = document.getElementById('cart-icon-bubble');
        if (bn && bc) bc.innerHTML = bn.innerHTML;
      }
    } catch (e) {}
  }
  function refreshDrawer(expectItems) {
    return _fetch('/?sections=cart-drawer,cart-icon-bubble', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (sections) { applyDrawer(sections, expectItems); })
      .catch(function () {});
  }

  var working = false;
  function reconcile() {
    if (working) return;
    working = true;
    getCart().then(function (cart) {
      var ref = getRef();
      if (!ref) { working = false; return; }

      var harnessCount = countHarnesses(cart);
      var lastCount    = getLastCount();
      var desired      = desiredGift(cart);
      var bandanaLines = linesFor(cart, BANDANA_VARIANT_ID);
      var refillLines  = linesFor(cart, REFILL_VARIANT_ID);   // FREE gift only
      var hasBandana   = bandanaLines.length > 0;
      var hasRefill    = refillLines.length > 0;
      var desiredPresent   = (desired === 'bandana' && hasBandana) || (desired === 'refill' && hasRefill);
      var wrongGiftPresent = (desired === 'bandana' && hasRefill) || (desired === 'refill' && hasBandana);

      // Strip any free gift that isn't the desired one, plus duplicates of the desired one.
      var removeKeys = [];
      if (desired === 'bandana') { bandanaLines.slice(1).forEach(function (l) { removeKeys.push(l.key); }); }
      else { bandanaLines.forEach(function (l) { removeKeys.push(l.key); }); }
      if (desired === 'refill') { refillLines.slice(1).forEach(function (l) { removeKeys.push(l.key); }); }
      else { refillLines.forEach(function (l) { removeKeys.push(l.key); }); }

      // Add on a NEW harness (count up) or a size swap (wrong gift sitting there).
      // Manual removal without a new harness does NOT re-add.
      var needAdd = harnessCount > 0 && desired !== 'none' && !desiredPresent &&
                    (harnessCount > lastCount || wrongGiftPresent);

      setLastCount(harnessCount);

      var pre = [];
      if (harnessCount > 0 && (!cart.attributes || cart.attributes[ATTR_KEY] !== ref)) pre.push(writeRef(ref));
      removeKeys.forEach(function (k) { pre.push(removeLine(k)); });

      if (!needAdd && pre.length === 0) { working = false; return; }

      Promise.all(pre).then(function () {
        if (needAdd) {
          var giftId = desired === 'bandana' ? BANDANA_VARIANT_ID : REFILL_VARIANT_ID;
          return addGift(giftId).then(function (data) { applyDrawer(data.sections, true); });
        }
        if (removeKeys.length > 0) return refreshDrawer(harnessCount > 0);
      }).catch(function () {}).then(function () { working = false; });
    }).catch(function () { working = false; });
  }

  // Debounced triggers — a burst of cart ops collapses into one reconcile.
  var debTimer = null;
  function schedule(delay) { clearTimeout(debTimer); debTimer = setTimeout(reconcile, delay || 500); }

  document.addEventListener('DOMContentLoaded', function () { schedule(400); });
  document.addEventListener('click', function (e) {
    if (e.target.closest('#cart-icon-bubble, .cart-drawer__open, a[href="/cart"], a[href^="/cart?"]')) schedule(500);
  });
  if (window.subscribe && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
    try { window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, function () { schedule(500); }); } catch (e) {}
  }
  // Detector for OTHER code's cart mutations (Dawn ATC, upsell app). Our own calls
  // use _fetch above, so they bypass this and can't self-trigger.
  window.fetch = function () {
    var url = arguments[0];
    var p = _fetch.apply(this, arguments);
    if (typeof url === 'string' && url.indexOf('sections=') === -1 &&
        (url.indexOf('/cart/add') !== -1 || url.indexOf('/cart/change') !== -1 || url.indexOf('/cart/update') !== -1)) {
      p.then(function () { schedule(500); });
    }
    return p;
  };
})();